import React from 'react';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router-dom';
import DLMCalendar from './DLMCalendar';

const DLMDetailsDetails = observer(() => {
  const { dlmid } = useParams<{ dlmid: string }>();

  return (
    <div style={{ width: '100%' }}>
      <DLMCalendar />
    </div>
  );
});

export default DLMDetailsDetails;
